import * as Sentry from '@sentry/browser';
import { SENTRY_DSN, ENVIRONMENT, VERSION } from './config';
import Cookies from 'universal-cookie';
import findQhUserId from './lib/findQhUserId';
import map from 'lodash/map';
import get from 'lodash/get';
import some from 'lodash/some';
import truncate from 'lodash/truncate';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';

const ignoredErrors = [
  /InvalidStateError: InvalidStateError/,
  /webkitExitFullScreen/,
  /Blocked a frame with origin .* from accessing .* frame/,
  /Out of memory/,
  /null is not an object \(evaluating 'document\.querySelector\('meta\[name="hotels-booking-stage"\]'\)\.getAttribute'\)/,
  /expected expression, got '<'/,
  /Loading chunk/,
];

const networkPatterns = [/(services|accounts)(.*)\.qantas/, /demdex/, /celebrus/, /xg4ken/, /doubleclick/, /hotjar/, /google-analytics/];

const breadcrumbFiltering = (breadcrumb, hint) => {
  // Filter SSO console logs
  if (/QLoginWidget/.test(breadcrumb.message)) return null;

  // Filter simplicity initialisation
  if (breadcrumb.message === 'ul.primary_navigation. > li.primary_navigation_item._focus_removed') return null;

  // Filter 3rd party network requests
  const url = get(breadcrumb, 'data.url');
  if (url && some(networkPatterns, (pattern) => url.match(pattern))) return null;

  // Better breadcrumbs on click
  if (breadcrumb.category === 'ui.click') {
    try {
      const target = hint.event.target;

      const text = target.getAttribute('data-hj-suppress') ? 'REDACTED' : truncate(target.textContent, { length: 50 });

      const data = {
        tag: `<${target.tagName.toLowerCase()}>`,
        title: target.getAttribute('title'),
        testId: target.getAttribute('data-testid'),
        altText: target.getAttribute('alt'),
        text,
      };
      breadcrumb.message = map(pickBy(data, identity), (v, k) => `${k}: ${v}`).join(', ');
    } catch (error) {
      return null;
    }
  }

  return breadcrumb;
};

const getUserId = () => findQhUserId(new Cookies());

if (SENTRY_DSN && VERSION && ['production', 'staging', 'sit'].includes(ENVIRONMENT)) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    release: VERSION,
    whitelistUrls: [/^(http|https):.*qantas.*/],
    ignoreErrors: ignoredErrors,
    maxBreadcrumbs: 100,
    beforeBreadcrumb: breadcrumbFiltering,
  });

  Sentry.configureScope((scope) => {
    scope.setUser({ id: getUserId() });
  });
} else {
  console.log('Sentry disabled'); // eslint-disable-line no-console
}
